import { useRouter } from 'next/router';
import { QueryClient, useQuery } from '@tanstack/react-query';
import { fetchUserFeedback } from '~/api/locker';
import { minutes30inMS } from '../../constants/times';
import { NextPageContext } from 'next';
import { LockerFeedbackQuery } from '../../pages/locker/[username]/feedback';
import { UseQueryResult } from '@tanstack/react-query';
import { RailsUserFeedback } from '~/typings/services/rails/user';
import { ApiPaginatedResponse } from 'fetcher-session';

export function prefetchLockerFeedback(
  query: LockerFeedbackQuery,
  queryClient: QueryClient,
  ctx: NextPageContext,
) {
  return queryClient.fetchQuery(
    ['lockers-feedback', query.username, query.page || 1],
    () =>
      fetchUserFeedback.call(ctx, query.username, undefined, query.page || 1),
  );
}

export default function useLockerFeedback(): UseQueryResult<
  ApiPaginatedResponse<RailsUserFeedback[]>
> {
  const router = useRouter();

  return useQuery(
    ['lockers-feedback', router.query.username, router.query.page || 1],
    () =>
      fetchUserFeedback(
        router.query.username,
        undefined,
        router.query.page || 1,
      ),
    {
      staleTime: minutes30inMS,
    },
  );
}
